<template>
  <div
    id="create-saved-grocery"
    class="page-content"
  >
    <div class="row">
      <div class="col-12">
        <create-new-saved-grocery />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useRoute } from 'vue-router';
import { onMounted, nextTick } from 'vue';
// User-defined components
import CreateNewSavedGrocery from './Grocery/SavedGrocery/CreateSavedGrocery.vue';
import util from '@/Utils/util';

export default {
  name: 'CreateSavedGrocery',

  components: {
    CreateNewSavedGrocery,
  },

  setup: () => {
    const route = useRoute();

    onMounted(async () => {
      const hash = route.hash;

      await nextTick();
      util.moveScrollComponent(hash);
    });
  },
};
</script>
